import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { TopMenuAPI } from '@business/api/top_menu';
import { TopMenuId, TopMenuResponse, TopMenuSorting, UpdateUserPermissionRequest } from '@business/entities/top_menu';
import { UserId } from '@business/entities/account';
import { UserPermissionAPI } from '@business/api/user_permissions';

export class UserPermissionBloc extends BaseBloc {
  private readonly modules = new Repository<TopMenuResponse>({
    getItemId: topMenu => topMenu.id,
  });

  readonly modules$ = this.modules.items$;
  readonly selectModule = this.modules.selectItem;

  onReset() {
    this.modules.reset();
  }

  fetchPermissions = (id: UserId) => {
    return UserPermissionAPI.fetchPermissions(id).pipe(handleMessage({ error: requestMessage('fetch_top_menu_error') }));
  };

  patchPermissions = (params: UpdateUserPermissionRequest) => {
    return UserPermissionAPI.patchPermissions(params).pipe(
      handleMessage({
        type: requestMessage('update_permission_error'),
      }),
    );
  };
}
